import React, { useContext, useState, useEffect } from 'react';
import ThemeContext from '../context/ThemeContext';

export default function Hero() {
    const { theme, toggleTheme } = useContext(ThemeContext);
    const [isReduced, setIsReduced] = useState(false);
    const [showButton, setShowButton] = useState(true);

    // Check if user has interacted before
    useEffect(() => {
        const hasInteracted = sessionStorage.getItem('hasInteracted');
        if (hasInteracted) {
            setIsReduced(true);
            setShowButton(false);
        }
    }, []);

    const handleProceed = () => {
        sessionStorage.setItem('hasInteracted', 'true');
        setIsReduced(true);
        
        // Hide button immediately when clicked
        setShowButton(false);
    };

    // Dynamic classes based on state
    const heroContainerClass = `container__hero ${isReduced ? 'reduced' : ''}`;
    const heroClass = `hero ${isReduced ? 'reduced' : ''}`;

    return (
        <div className={heroContainerClass}>
            <div className={heroClass}>
                {/* Theme toggle switch positioned at bottom right */}
                <div className="theme-switch-wrapper hero-theme-toggle">
                    <span className="theme-switch-label">Light Mode</span>
                    <label className="theme-switch">
                        <input 
                            type="checkbox" 
                            checked={theme === 'dark'} 
                            onChange={toggleTheme}
                        />
                        <span className="slider round"></span>
                    </label>
                    <span className="theme-switch-label">Dark Mode</span>
                </div>
                
                {/* Proceed button - only visible in full screen or during transition */}
                {showButton && (
                    <div className="proceed-container">
                        <button 
                            className="proceed-button"
                            onClick={handleProceed}
                            aria-label="Proceed to main content"
                        >
                            Explore Manuscripts
                            <i className="fas fa-arrow-down"></i>
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}